import { render, staticRenderFns } from "./ZaloEditModal.vue?vue&type=template&id=e87f6290&scoped=true"
import script from "./ZaloEditModal.vue?vue&type=script&lang=js"
export * from "./ZaloEditModal.vue?vue&type=script&lang=js"
import style0 from "./ZaloEditModal.vue?vue&type=style&index=0&id=e87f6290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87f6290",
  null
  
)

export default component.exports